const ignoreErrors = [
  'Non-Error exception',
  'Loading chunk',
  'ResizeObserver loop limit exceeded',
  'Unexpected token < in JSON at position 0',
  'SecurityError: Blocked a frame with origin',
  'Type',
  'Illegal invocation',
  'Non-Error exception captured',
  'Non-Error promise rejection captured',
  'LaunchDarklyFlagFetchError',
  'Response not successful: Received status code 401',
  `Unexpected token '='`,
  'A network error occurred.',
  `Can't find variable: __AutoFillPopupClose__`,
  `Failed to read the 'localStorage' property from 'Window': Access is denied for this document`,
  `Can't find variable: gmo`, // Can be removed once https://issuetracker.google.com/issues/396043331?pli=1 is fixed
  'Failed to load https://www.googletagmanager.com', // External JS file loading
  'Failed to load Stripe.js', // External JS file loading
  'No error message', // Uknown error but looks not to be in our code
  'Unexpected private name #e.', // Looks to be internal to New Relic
  'Java object is gone', // Mobile Chromium issue, won't be fixed https://issues.chromium.org/issues/351434157/resources
  'Response not successful: Received status code 422', // Looks to be internal to New Relic
  'Invalid call to runtime.sendMessage(). Tab not found.', // Probably browser extension
  'Failed to fetch', // GraphQL connection issue
  'Load failed', // GraphQL connection issue
  'Error invoking initializeCallbackHandler: Java exception was raised during method invocation', // Error from Facebook Mobile browser (https://github.com/getsentry/sentry-javascript/issues/15065)
  'invalid origin', // Likely a side effect of tracker blocking (i.e., DuckDuckGo browser)
  'feature named `performanceMetrics` was not found', // Likely a side effect of metrics blocking (i.e., DuckDuckGo browser)
  'GraphQL Error: {"message":"Something broke"}', // This is an expected error from our e2e tests
];

export const config = {
  ignoreErrors,
};
